import React from 'react';
import isBefore from 'date-fns/isBefore';
import isEqual from 'date-fns/isEqual';
import format from 'date-fns/format';
import parse from 'date-fns/parse';
import addMinutes from 'date-fns/addMinutes';

class TimePicker extends React.Component {
  render() {
    if (this.props.selected === null) return /*#__PURE__*/React.createElement("div", {
      className: "timepicker"
    });
    const now = new Date();
    const timeslots = [];
    const dayOfTheWeek = this.props.selected.getDay() ? this.props.selected.getDay() - 1 : 6;

    for (let i = 0; i < this.props.creneaux[dayOfTheWeek].length; ++i) {
      timeslots.push([]);
      const creneau = this.props.creneaux[dayOfTheWeek][i];
      let startDate = parse(creneau.start, 'HH:mm', this.props.selected);
      const endDate = parse(creneau.end, 'HH:mm', this.props.selected);
      timeslots[i].push(startDate);

      while (startDate < endDate) {
        startDate = addMinutes(startDate, 15);
        timeslots[i].push(startDate);
      }
    }

    return /*#__PURE__*/React.createElement("div", {
      className: "timepicker"
    }, timeslots.map((t, i) => /*#__PURE__*/React.createElement("div", {
      key: i,
      className: "timepicker-slot"
    }, t.map(date => isBefore(date, now) ? /*#__PURE__*/React.createElement("span", {
      className: 'disabled',
      key: date.getTime()
    }, format(date, 'HH:mm')) : /*#__PURE__*/React.createElement("span", {
      className: isEqual(this.props.selected, date) && 'selected',
      key: date.getTime(),
      onClick: () => this.props.onChange(date)
    }, format(date, 'HH:mm'))))));
  }

}

export default TimePicker;